module.exports = __webpack_public_path__ + "img/class_default.bd87799f.png";